import { authRequest } from './utils';

export const fetchHubstaffProjects = () =>
  authRequest({
    method: 'GET',
    url: `/hubstaff/projects`,
  }).then(({ data }) => data);
